import { forwardRef } from "react";

import { type ButtonProps, Button as ChakraButton } from "@chakra-ui/react";

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { colorPalette = "gray", size = "xl", variant = "solid", ...props },
    ref,
  ) => {
    return (
      <ChakraButton
        ref={ref}
        {...props}
        colorPalette={colorPalette}
        size={size}
        variant={variant}
      />
    );
  },
);
